import apiClient from "config/api";

const getFeedbacks = async () => {
  return apiClient.get("/admin/feedbacks");
};

const deleteFeedback = async (feedbackId) => {
  return apiClient.delete(`/admin/feedbacks/${feedbackId}`);
};

const deleteMultipleFeedbacks = async (feedbackIds) => {
  return apiClient.post("/admin/feedbacks/delete-multiple", { feedbackIds });
};

const archiveFeedback = async (feedbackId) => {
  return apiClient.patch(`/admin/feedbacks/${feedbackId}/archive`);
};

const unarchiveFeedback = async (feedbackId) => {
  return apiClient.patch(`/admin/feedbacks/${feedbackId}/unarchive`);
};

const archiveMultipleFeedbacks = async (feedbackIds) => {
  return apiClient.post("/admin/feedbacks/archive-multiple", { feedbackIds });
};

const unarchiveMultipleFeedbacks = async (feedbackIds) => {
  return apiClient.post("/admin/feedbacks/unarchive-multiple", { feedbackIds });
};

export {
  getFeedbacks,
  deleteFeedback,
  deleteMultipleFeedbacks,
  archiveFeedback,
  unarchiveFeedback,
  archiveMultipleFeedbacks,
  unarchiveMultipleFeedbacks,
};
